import { render, staticRenderFns } from "./meal_card.vue?vue&type=template&id=6f85ab2e&scoped=true&lang=html&"
import script from "./meal_card.vue?vue&type=script&lang=js&"
export * from "./meal_card.vue?vue&type=script&lang=js&"
import style0 from "./meal_card.vue?vue&type=style&index=0&id=6f85ab2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85ab2e",
  null
  
)

export default component.exports